module.exports = __webpack_public_path__ + "img/straight-rail-diagonal-right-top-backplates.787fa782.png";